import API from 'API/index'
import {enqueueSnackbar as enqueueSnackbarAction} from 'store/actions/notifier'
import * as typeNotifier from 'shared/typeNotifications'
import * as informationMessages from 'constants/infoMessages'

export const START_LOAD_GENERAL_STATISTIC = 'START_LOAD_GENERAL_STATISTIC'
export const SUCCESS_LOAD_GENERAL_STATISTIC = 'SUCCESS_LOAD_GENERAL_STATISTIC'
export const LOAD_DYNAMIC_DATA_GENERAL_STATISTIC = 'LOAD_DYNAMIC_DATA_GENERAL_STATISTIC'
export const ERROR_LOAD_GENERAL_STATISTIC = 'ERROR_LOAD_GENERAL_STATISTIC'
export const DATE_CHANGE_GENERAL_STATISTIC = 'DATE_CHANGE_GENERAL_STATISTIC'

export const loadDataCommonMetrics = (dateRange, t) => dispatch => {
  dispatch({type: START_LOAD_GENERAL_STATISTIC})
  API.getDataCommonMetrics(dateRange)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_GENERAL_STATISTIC,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_GENERAL_STATISTIC,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
      console.error('LOAD_ALL_CHARTS_GENERAL_STATISTIC')
    })
}
export const loadDynamicData = () => dispatch => {
  API.getDataCommonMetrics()
    .then(({data}) => {
      dispatch({
        type: LOAD_DYNAMIC_DATA_GENERAL_STATISTIC,
        data,
      })
    })
    .catch(() => {
      console.error('LOAD_DYNAMIC_DATA_GENERAL_STATISTIC')
    })
}
